import styled from 'styled-components';

export const Container = styled.div`
  align-items: center;
`;

export const MessagesPool = styled.div`
  display: flex;
  width: 95%;
  /* min-height: 100vh; */
  flex-flow: row wrap;
  gap: 4rem;
  margin: 1rem 0;
`;

export const CardMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 22rem;
  height: 75vh;
  overflow: hidden;
  background-color: var(--itemBackground);
`;

export const CardMessageHeader = styled.div<{ status: string }>`
  display: flex;
  width: -webkit-fill-available;
  align-items: center;
  min-height: 3rem;
  background-color: ${props =>
    // eslint-disable-next-line no-nested-ternary
    props.status === 'Confirmada'
      ? `var(--confirmed-background)`
      : props.status === 'Aguardando'
      ? `var(--waiting-background)`
      : `var(--notConfirmed-background)`};
  color: var(--white);
  font-weight: 700;

  svg {
    color: var(--white);
    margin: 0 1rem;
  }
`;

export const CardMessageHeaderText = styled.div`
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-height: 16px; /* fallback */
  max-height: 32px; /* fallback */
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
`;

export const CardMessageContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 0.5rem;
  width: -webkit-fill-available;
  overflow-y: auto;
  background-color: var(--white);
`;

export const CardMessageContentHeader = styled.div`
  display: flex;
  img {
    width: 20%;
    object-fit: cover;
    min-height: 2rem;
  }
  strong {
    font-size: 1rem;
  }
`;

export const CardMessageContentHeaderTitle = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 0.5rem;
`;

export const CardMessageContentHeaderInfo = styled.div`
  margin-top: 0.5rem;
  svg {
    margin-right: 0.5rem;
  }
  strong {
  }
`;

export const CardMessageContentText = styled.div`
  display: flex;
  flex-direction: column;
  color: var(--text);
  padding: 0.2rem;
  p {
    & + p {
      margin-top: 0.5rem;
    }
  }

  svg {
    margin-right: 0.3rem;
  }
`;

export const CardMessageContentInfo = styled.div`
  width: -webkit-fill-available;
  border: solid 1px var(--borderMedium);
  border-radius: 0.5rem;
  margin: 0.5rem 0 0 0;
  font-size: 0.8rem;
  background-color: var(--white);
`;

export const CardMessageContentInfoHeader = styled.div<{
  tipo: 'regras' | 'convidados';
}>`
  display: flex;
  justify-content: center;
  padding: 0.3rem;
  background-color: ${props =>
    props.tipo === 'regras' ? '#17a2b8' : 'var(--primary)'};
  color: var(--white);
  font-weight: 700;
  border-top-left-radius: 0.45rem;
  border-top-right-radius: 0.45rem;
`;

export const CardMessageFooter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 3rem;
  width: -webkit-fill-available;
  color: var(--white);
  background-color: var(--backgroundFooterDark);
  border-top: solid 1px var(--inputBorder);
`;

export const CardMessageFooterInfoContainer = styled.div`
  display: flex;
  font-size: 0.8rem;
  margin: 0.2rem 0;
  svg {
    margin: 0 0.5rem;
  }
`;

export const CarMessageContentButtons = styled.div`
  display: flex;
  width: -webkit-fill-available;

  button {
    :first-child {
      margin-right: 0.5rem;
    }
  }
`;
